import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
    permissionsIcon: {
        position: "absolute",
        fontSize: 20,
        left: 52,
        bottom: 0,
    },
}));

export const ContactPermissionSummary = ({ permissions, isContactsCard, adviceTypeIds }) => {
    const classes = useStyles();

    const updatePermissionName = (permission) => {
        switch (permission) {
            case "Casenest Administrator":
                return "System Administrator";                
            case "Casenest Receive Advice":
                return "Can Receive Advice";      
            case "Casenest All Cases":
                return "Access to all cases";                
            default:
                return "None";
        }
    };

    return (
        <Tooltip
            title={
                <Box display="flex" flexDirection="column" p={2}>
                    <Typography variant="subtitle1">Access:</Typography>
                    {permissions?.length ? (
                        permissions.map((permission) => (
                            <Typography key={permission}>
                                - {updatePermissionName(permission)}
                            </Typography>
                        ))
                    ) : (
                        <Typography>- None</Typography>
                    )}
                </Box>
            }
            arrow
            placement="right-start"
        >
            <InfoIcon
                className={!isContactsCard ? "" : classes.permissionsIcon}
            />
        </Tooltip>
    );
};

export default ContactPermissionSummary;
